import { ComponentsProps } from "@thisgorilla/primate-ds";
import { ArticleProps } from "../../../../redux/slices/article/Article";

export const mediaTypelist: {
  iconType: ComponentsProps.IconButtonProps.IProps["iconType"];
  type: ArticleProps.ContentTypeDesc;
  label: string;
}[] = [
  {
    iconType: "Type",
    type: "text",
    label: "Text block",
  },
  {
    iconType: "Image",
    type: "image",
    label: "Image",
  },
  {
    iconType: "AudioNew",
    type: "audio",
    label: "Audio",
  },
  {
    iconType: "VideoNew",
    type: "video",
    label: "Video",
  },
  {
    iconType: "Poll",
    type: "poll",
    label: "Poll",
  },
  {
    iconType: "Slider",
    type: "rating",
    label: "Rate",
  },
  {
    iconType: "Code",
    type: "embed",
    label: "Embed",
  },
];
